import { z } from 'zod';
import { optionalNullableDateInput, optionalUuidString, requiredUuidString, } from '../zod-helpers/index.js';
import { MAX_PART_LINES_PER_CREATE, MAX_PART_LINES_PER_CREATE_MESSAGE, PURCHASE_ORDER_CONSTRAINTS, } from './constraints.js';
import { purchaseOrderQuantitySchema } from './item-quantity.js';
import { purchaseOrderUnitCostBoundsSchema } from './item-unit-cost.js';
/** Empty string → null so optional selects cannot smuggle "" as a UUID override. */
const optionalNullishUuid = (invalidMessage) => optionalUuidString(invalidMessage)
    .transform((value) => (value.trim() === '' ? null : value))
    .optional()
    .nullable();
export const createPurchaseOrdersFromPartsItemSchema = z.object({
    partId: requiredUuidString(`${PURCHASE_ORDER_CONSTRAINTS.part.label} is required.`, 'Invalid part selection.'),
    quantity: purchaseOrderQuantitySchema,
    vendorId: optionalNullishUuid(`Invalid ${PURCHASE_ORDER_CONSTRAINTS.vendorOverride.label.toLowerCase()} selection.`),
    unitCost: z
        .number({
        error: (issue) => typeof issue.input === 'number' && !Number.isFinite(issue.input)
            ? `${PURCHASE_ORDER_CONSTRAINTS.unitCost.label} must be a finite number.`
            : undefined,
    })
        .pipe(purchaseOrderUnitCostBoundsSchema)
        .optional()
        .nullable(),
});
export const createPurchaseOrdersFromPartsInputSchema = z.object({
    locationGroupId: requiredUuidString(`${PURCHASE_ORDER_CONSTRAINTS.locationGroup.label} is required.`, `Invalid ${PURCHASE_ORDER_CONSTRAINTS.locationGroup.label.toLowerCase()} selection.`),
    brandId: requiredUuidString(`${PURCHASE_ORDER_CONSTRAINTS.brand.label} is required.`, 'Invalid brand selection.'),
    vendorId: requiredUuidString(`${PURCHASE_ORDER_CONSTRAINTS.vendor.label} is required.`, 'Invalid vendor selection.'),
    paymentTermsId: requiredUuidString(`${PURCHASE_ORDER_CONSTRAINTS.paymentTerms.label} is required.`, 'Invalid payment terms selection.'),
    fobPointId: optionalNullishUuid(`Invalid ${PURCHASE_ORDER_CONSTRAINTS.fobPoint.label.toLowerCase()} selection.`),
    expectedDeliveryDate: optionalNullableDateInput,
    note: z
        .string()
        .max(PURCHASE_ORDER_CONSTRAINTS.note.maxLength, `${PURCHASE_ORDER_CONSTRAINTS.note.label} must be ${PURCHASE_ORDER_CONSTRAINTS.note.maxLength} characters or fewer.`)
        .optional()
        .nullable(),
    items: z
        .array(createPurchaseOrdersFromPartsItemSchema)
        .min(1, 'At least one part to order is required.')
        .max(MAX_PART_LINES_PER_CREATE, MAX_PART_LINES_PER_CREATE_MESSAGE),
});
//# sourceMappingURL=create-input.js.map